/* Herram · Ajustes generales
   CARRITO
   1) Casilla de Términos y Condiciones sin marcar por defecto: el cliente debe aceptarla
      de forma expresa (Ley 19.496). La app de términos sigue bloqueando el pago hasta que se marque.
      Si el cliente la toca, se respeta su elección.
   2) Aviso bajo "Pagar pedido" mientras falte elegir región y comuna (grafito, nunca naranjo).
   2b) «Solicitar factura» pasa al resumen como casilla; el enlace de términos apunta a herram.cl;
       en celular, barra fija abajo con el total y «Continuar» mientras el botón de pago no se ve.
   FICHA DE PRODUCTO
   3) Las líneas "- Clave: valor" de la descripción (formato que envía Yuju) se muestran como tabla
      de especificaciones, y las líneas "- texto" como lista. El texto guardado no se modifica.
      15-oct-2026: también "- Clave<tabulación>valor" (algunas fichas de Yuju vienen sin los dos puntos).
   BUSCADOR
   0) Códigos sin puntos ni guiones (2608619290, D71308, YT7377) encuentran el producto: se confirma el SKU real.
   COLECCIONES Y BÚSQUEDA
   4) Se ocultan los filtros que aplican a menos de 3 productos de la página (ruido),
      salvo Precio, Marca y Disponibilidad, y nunca uno que el cliente esté usando.
      15-oct-2026: el filtro de precio dice «Desde / Hasta» (la traducción decía «De / Para»).
   5) En celular, la descripción de la colección muestra 2 líneas y un botón «Leer más». */
(function () {
  var path = location.pathname;

  /* ---------- Buscador: códigos escritos sin puntos, guiones o espacios ----------
     Los SKU vienen de Yuju con puntuación (2608.619.290-000, D-71308, YT-7377…) y el buscador de Shopify
     solo los encuentra escritos igual. Si lo escrito parece un código, se prueban los formatos de cada marca,
     se confirma contra el SKU real del producto y se busca con el SKU exacto. Solo actúa con códigos. */
  var H_CODE = { cache: {} };
  function hCodeCandidates(q) {
    var raw = (q || '').trim();
    if (!raw || raw.length > 24) return [];
    if (/[A-Za-zÁÉÍÓÚáéíóúñÑ]{4,}/.test(raw)) return [];          // tiene palabras: no es un código
    var c = raw.toUpperCase().replace(/[.\-\s\/]/g, '');
    if (!/^[A-Z0-9]{5,16}$/.test(c) || !/\d{3}/.test(c)) return [];
    var out = [], m, add = function (s) { if (out.indexOf(s) === -1) out.push(s); };
    if ((m = c.match(/^(\d{4})([A-Z0-9]{3})([A-Z0-9]{3})(\d{2,3})?$/))) add(m[1] + '.' + m[2] + '.' + m[3] + (m[4] ? '-' + m[4] : ''));   // Bosch, Dremel 2608.619.290-000
    if ((m = c.match(/^([A-Z])(\d{5})(\d{1,2})?$/))) add(m[1] + '-' + m[2] + (m[3] ? '-' + m[3] : ''));                                   // Makita D-71308
    if ((m = c.match(/^([A-Z]{2})(\d{4,5})$/))) add(m[1] + '-' + m[2]);                                                                 // Yato YT-7377
    if ((m = c.match(/^([A-Z]{2,3}\d{3,5})([A-Z]{2})$/))) add(m[1] + '-' + m[2]);                                                      // DeWALT DW4772-LA, Stanley STA32177-XJ
    if ((m = c.match(/^([0-9][0-9A-Z]{5})(\d)$/))) add(m[1] + '-' + m[2]);                                                              // Makita 225042-5, 632H78-9
    if ((m = c.match(/^(\d{2,3}[A-Z]?)(\d{2,3}[A-Z]?)(\d)$/))) add(m[1] + '-' + m[2] + '-' + m[3]);                                     // Irimo 130-94-4, 648-250-1
    if ((m = c.match(/^(\d{3})(\d{4})(\d{2})$/))) add(m[1] + ' ' + m[2] + '-' + m[3]);                                                  // Husqvarna 581 6266-84
    if ((m = c.match(/^(\d{4})(\d{3})(\d{4})$/))) add(m[1] + ' ' + m[2] + ' ' + m[3]);                                                  // Stihl 4006 710 2121
    if ((m = c.match(/^(\d{3})(\d{2})$/))) add(m[1] + '-' + m[2]);                                                                      // Timberline 100-01
    if ((m = c.match(/^(\d{2})(\d{3})$/))) add(m[1] + '-' + m[2]);                                                                      // Stanley 30-088
    if ((m = c.match(/^(\d{4})(\d{2})$/))) add(m[1] + '-' + m[2]);                                                                      // Bahco 3832-60
    if ((m = c.match(/^(\d)(\d{3})(\d{2})(\d)(\d)$/))) add([m[1], m[2], m[3], m[4], m[5]].join('-'));                                   // Bahco 1-100-06-1-2
    return out.filter(function (s) { return s !== raw.toUpperCase(); }).length || out.indexOf(raw.toUpperCase()) === -1 ? out : [];
  }
  var hCompact = function (s) { return (s || '').toUpperCase().replace(/[.\-\s\/]/g, ''); };
  var hResolveCode = function (q) {
    var key = hCompact(q);
    if (H_CODE.cache[key] !== undefined) return Promise.resolve(H_CODE.cache[key]);
    var cands = hCodeCandidates(q).slice(0, 3);
    if (!cands.length) return Promise.resolve(null);
    var nf = window.__hNativeFetch || window.fetch;
    var tryOne = function (i) {
      if (i >= cands.length) return Promise.resolve(null);
      return nf('/search/suggest.json?q=' + encodeURIComponent(cands[i]) + '&resources[type]=product&resources[limit]=4')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = ((d.resources || {}).results || {}).products || [];
          return Promise.all(ps.map(function (p) {
            return nf(p.url.split('?')[0] + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
          }));
        })
        .then(function (prods) {
          /* SKU idéntico: se busca ese SKU. Si solo calza el comienzo (falta el -000 o -10 final), se busca
             el código formateado, que trae todas sus versiones (unidad y pack). */
          var prefix = false;
          for (var a = 0; a < prods.length; a++) {
            var vs = (prods[a] && prods[a].variants) || [];
            for (var b = 0; b < vs.length; b++) {
              var sk = hCompact(vs[b].sku);
              if (!sk) continue;
              if (sk === key) return vs[b].sku;
              if (sk.indexOf(key) === 0) prefix = true;
            }
          }
          return prefix ? cands[i] : tryOne(i + 1);
        })
        .catch(function () { return tryOne(i + 1); });
    };
    return tryOne(0).then(function (sku) { H_CODE.cache[key] = sku; return sku; });
  };

  /* Sugerencias mientras se escribe: se cambia el texto buscado por el SKU real */
  if (window.fetch && !window.__hNativeFetch) {
    window.__hNativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/search/suggest') !== -1 && url.indexOf('section_id=') !== -1) {
        try {
          var u = new URL(url, location.origin), q = u.searchParams.get('q');
          if (q && hCodeCandidates(q).length) {
            return hResolveCode(q).then(function (sku) {
              if (!sku) return window.__hNativeFetch(input, init);
              u.searchParams.set('q', sku);
              /* El texto «Buscar …» debe seguir mostrando lo que escribió el cliente (lo usa predictive-search.js) */
              return window.__hNativeFetch(u.pathname + u.search, init).then(function (r) {
                return r.text().then(function (html) {
                  html = html.replace(/(data-predictive-search-search-for-text[^>]*>)([\s\S]*?)(<\/)/, function (all, a, txt, z) { return a + txt.split(sku).join(q) + z; });
                  return new Response(html, { status: r.status, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
                });
              });
            });
          }
        } catch (e) {}
      }
      return window.__hNativeFetch(input, init);
    };
  }

  /* Al presionar Enter o la lupa: se va a los resultados del SKU real */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/search') === -1 || f.dataset.hCode === 'ok') return;
    var inp = f.querySelector('input[name="q"]');
    var q = inp && inp.value;
    if (!q || !hCodeCandidates(q).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    hResolveCode(q).then(function (sku) {
      if (sku) inp.value = sku;
      f.dataset.hCode = 'ok';
      f.submit();
    });
  }, true);


  /* 20-oct-2026: si se llega a /search con un código sin puntuación (enlace, barra del navegador, Google),
     se cambia a la búsqueda con el SKU real. */
  if (path.indexOf('/search') === 0) {
    try {
      var hU = new URL(location.href), hQ = hU.searchParams.get('q');
      if (hQ && hCodeCandidates(hQ).length) {
        hResolveCode(hQ).then(function (sku) {
          if (sku && sku !== hQ) { hU.searchParams.set('q', sku); location.replace(hU.pathname + hU.search); }
        });
      }
    } catch (e) {}
  }

  /* ---------- Carrito ---------- */
  if (path.indexOf('/cart') === 0) {
    var touched = false;
    document.addEventListener('click', function (e) {
      if (e.isTrusted && e.target && (e.target.id === 'rterms-0' || (e.target.closest && e.target.closest('label[for="rterms-0"], .rterms')))) touched = true;
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.isTrusted && document.activeElement && document.activeElement.id === 'rterms-0') touched = true;
    }, true);
    var start = Date.now();
    var t = setInterval(function () {
      var cb = document.getElementById('rterms-0');
      if (!touched && cb && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (touched || Date.now() - start > 8000) clearInterval(t);
    }, 250);

    var hint = function () {
      var btn = document.getElementById('checkout');
      var region = document.getElementById('select-city');
      var comuna = document.getElementById('select-town');
      if (!btn || !region || !comuna) return;
      var box = document.getElementById('herram-checkout-hint');
      if (!box) {
        box = document.createElement('p');
        box.id = 'herram-checkout-hint';
        box.className = 'h-hint';
        box.setAttribute('role', 'status');
        btn.insertAdjacentElement('afterend', box);
      }
      var falta = !region.value || !comuna.value;
      box.textContent = falta ? 'Elige tu región y comuna arriba para continuar con el pago.' : '';
      box.style.display = falta ? '' : 'none';
    };
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'select-city' || e.target.id === 'select-town')) setTimeout(hint, 50);
    });

    var arrange = function () {
      /* Factura: del costado izquierdo al resumen, antes del total */
      var fact = document.querySelector('pivot-factura-inline');
      var blocks = document.querySelector('#main-cart-footer .cart__blocks');
      var totals = blocks && blocks.querySelector('.js-contents');
      if (fact && totals && fact.parentElement !== blocks) blocks.insertBefore(fact, totals);
      /* Términos: enlace al dominio de la tienda */
      var tl = document.querySelector('.terms-relentless a[href*="myshopify.com"]');
      if (tl) tl.setAttribute('href', '/policies/terms-of-service');
    };

    var sticky = function () {
      if (window.innerWidth >= 750 || document.getElementById('h-cart-bar')) return;
      var ctas = document.querySelector('#main-cart-footer .cart__ctas');
      var totalEl = document.querySelector('#main-cart-footer .totals__total-value');
      if (!ctas || !totalEl || document.querySelector('#main-cart-footer.is-empty')) return;
      var bar = document.createElement('div');
      bar.id = 'h-cart-bar';
      bar.innerHTML = '<div class="h-cart-bar__t"><span>Total estimado</span><b></b></div><button type="button" class="h-cart-bar__b">Continuar</button>';
      document.body.appendChild(bar);
      var setTotal = function () {
        var t = document.querySelector('#main-cart-footer .totals__total-value');
        bar.querySelector('b').textContent = t ? t.textContent.replace(/\s*CLP\s*$/, '').trim() : '';
      };
      setTotal();
      new MutationObserver(setTotal).observe(document.getElementById('main-cart-footer'), { childList: true, subtree: true, characterData: true });
      bar.querySelector('button').addEventListener('click', function () {
        var region = document.getElementById('select-city');
        var comuna = document.getElementById('select-town');
        var terms = document.getElementById('rterms-0');
        var go = function (el, focus) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (focus) setTimeout(function () { focus.focus({ preventScroll: true }); }, 400); };
        if (region && !region.value) return go(document.querySelector('.lab51-comunas') || region, region);
        if (comuna && !comuna.value) return go(document.querySelector('.lab51-comunas') || comuna, comuna);
        if (terms && !terms.checked) return go(ctas, terms);
        go(ctas, document.getElementById('checkout'));
      });
      /* Se oculta cuando el botón de pago ya está a la vista o más arriba */
      var ticking = false;
      var check = function () {
        ticking = false;
        var c = document.querySelector('#main-cart-footer .cart__ctas') || ctas;
        var hide = c.getBoundingClientRect().top < window.innerHeight - 40;
        bar.classList.toggle('is-hidden', hide);
        document.body.classList.toggle('h-has-cart-bar', !hide);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
    };

    window.addEventListener('load', function () {
      hint(); arrange(); sticky();
      setTimeout(function () { hint(); arrange(); }, 1500);
    });
  }

  /* ---------- Ficha de producto: especificaciones ---------- */
  if (path.indexOf('/products/') !== -1) {
    var specs = function () {
      document.querySelectorAll('.pivot-product-description__details > div').forEach(function (box) {
        if (box.dataset.hs) return;
        box.dataset.hs = '1';
        box.querySelectorAll('ul').forEach(function (u) { if (!u.textContent.trim()) u.remove(); });
        var parts = box.innerHTML.split(/<br\s*\/?>/i);
        var out = [], rows = [], items = [], para = [];
        var flushRows = function () { if (rows.length) { out.push('<table class="hs-table"><tbody>' + rows.join('') + '</tbody></table>'); rows = []; } };
        var flushItems = function () { if (items.length) { out.push('<ul class="hs-list">' + items.join('') + '</ul>'); items = []; } };
        var flushPara = function () { if (para.length) { out.push('<p>' + para.join('<br>') + '</p>'); para = []; } };
        parts.forEach(function (p) {
          var line = p.replace(/&nbsp;/g, ' ').trim();
          var text = line.replace(/<[^>]+>/g, '').trim();
          if (!text) { flushPara(); flushRows(); flushItems(); return; }
          /* Separador: dos puntos o tabulación (15-oct-2026) */
          var kv = line.match(/^[-•–]\s*([^:<\t]{1,45}?)\s*(?::|\t)\s*(.+)$/);
          if (kv) { flushPara(); flushItems(); rows.push('<tr><th scope="row">' + kv[1].trim() + '</th><td>' + kv[2].trim() + '</td></tr>'); return; }
          var li = line.match(/^[-•–]\s*(.+)$/);
          if (li) { flushPara(); flushRows(); items.push('<li>' + li[1] + '</li>'); return; }
          flushRows(); flushItems(); para.push(line);
        });
        flushPara(); flushRows(); flushItems();
        if (out.length) box.innerHTML = out.join('');
      });
    };
    if (document.readyState !== 'loading') specs(); else document.addEventListener('DOMContentLoaded', specs);
  }

  /* ---------- Colecciones y búsqueda: filtros con pocos productos ---------- */
  if (path.indexOf('/collections/') === 0 || path.indexOf('/search') === 0) {
    var MIN = 3;
    var trimFacets = function () {
      document.querySelectorAll('facet-filters-form details, menu-drawer details, .mobile-facets details').forEach(function (d) {
        var sum = d.querySelector('summary');
        var name = sum ? sum.textContent.trim().toLowerCase() : '';
        if (!name || /precio|marca|disponib/.test(name)) return;
        var inputs = d.querySelectorAll('input[type="checkbox"]');
        if (!inputs.length) return;
        var total = 0, active = false;
        inputs.forEach(function (i) {
          if (i.checked) active = true;
          var lab = i.closest('label') || (i.id && document.querySelector('label[for="' + i.id + '"]'));
          var m = lab ? lab.textContent.match(/\((\d+)\)/) : null;
          if (m) total += parseInt(m[1], 10);
        });
        d.style.display = (!active && total > 0 && total < MIN) ? 'none' : '';
      });
    };
    /* Filtro de precio: «Desde / Hasta» en vez de «De / Para» */
    var priceLabels = function () {
      var map = { 'De': 'Desde', 'Para': 'Hasta' };
      document.querySelectorAll('price-range label, .facets__price label').forEach(function (l) {
        var k = l.textContent.trim();
        if (map[k]) l.textContent = map[k];
      });
      document.querySelectorAll('price-range input, .facets__price input').forEach(function (i) {
        var k = (i.getAttribute('placeholder') || '').trim();
        if (map[k]) i.setAttribute('placeholder', map[k]);
      });
    };
    var run = function () { trimFacets(); priceLabels(); };
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    var grid = document.getElementById('ProductGridContainer') || document.body;
    new MutationObserver(function () { clearTimeout(window.__hfT); window.__hfT = setTimeout(run, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Colecciones en celular: descripción en 2 líneas + «Leer más» (Baymard: productos antes) ----------
     El texto completo sigue en la página (no se pierde para Google). Estilos en herram-buttons.css. */
  if (path.indexOf('/collections/') === 0) {
    var clampDesc = function () {
      var d = document.querySelector('.collection-hero__description');
      if (!d || d.dataset.hc || window.innerWidth >= 750) return;
      d.dataset.hc = '1';
      d.classList.add('h-clamp');
      if (d.scrollHeight <= d.clientHeight + 4) { d.classList.remove('h-clamp'); return; }
      if (!d.id) d.id = 'h-coll-desc';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'h-clamp-btn';
      btn.setAttribute('aria-controls', d.id);
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Leer más';
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Leer menos' : 'Leer más';
      });
      d.insertAdjacentElement('afterend', btn);
    };
    if (document.readyState !== 'loading') clampDesc(); else document.addEventListener('DOMContentLoaded', clampDesc);
  }
})();
/* Herram 20-oct-2026 (Jorge): el globo de WhatsApp (celular y PC) se oculta mientras tapa un botón, el total del carro,
   un campo o un selector (por ejemplo «Agregar al carrito» o la región del carro), y vuelve al despejarse. */
(function(){
  if(window.hWspOn)return;window.hWspOn=1;
  var mq=window.matchMedia('(max-width: 749px)'),q=0;
  var sel='button,select,input,textarea,a.button,.button,.quantity,[role=button],.totals,[id$="__esp"] a';
  function chk(){
    q=0;var g=document.querySelector('.globo-wsp');if(!g)return;
    g.style.visibility='hidden';
    var r=g.getBoundingClientRect(),hit=false,pts=[[r.left+4,r.top+4],[r.right-4,r.top+4],[r.left+4,r.bottom-4],[r.right-4,r.bottom-4],[r.left+r.width/2,r.top+r.height/2]];
    for(var i=0;i<pts.length&&!hit;i++){var e=document.elementFromPoint(pts[i][0],pts[i][1]);if(e&&e.closest&&e.closest(sel)&&!g.contains(e))hit=true;}
    g.style.visibility='';
    g.classList.toggle('hwsp-off',hit);
  }
  function go(){if(!q){q=1;requestAnimationFrame(chk);}}
  addEventListener('scroll',go,{passive:true});addEventListener('resize',go);
  document.addEventListener('DOMContentLoaded',go);addEventListener('load',go);setInterval(go,1200);
})();
